<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn :to="{ name: '_change_profile' }" icon width="40" height="40" class="mr-2">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.choose_verification') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-4">
            <div class="box-info pa-4 br-10">
              <div class="flex-image align-start">
                <div class="mr-2">
                  <img src="@/assets/images/v2/img/icon_info.png" alt="Info">
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14 font-weight-400 ol-black">
                    {{ $t('v2.verify_to_change_phone_number') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="la-list" style="margin: 0px -12px;">
            <div class="la-list-item large" @click="verify()">
              <div class="la-list-icon">
                <img src="@/assets/images/v2/img/icon_whatsapp.png" alt="Whatsapp">
              </div>
              <div class="la-list-content">
                <div class="la-list-item-text font-14 font-weight-600">
                  Whatsapp
                </div>
              </div>
            </div>
            <div class="div-line with-padding" />
            <div class="la-list-item large" @click="verify(1)">
              <div class="la-list-icon">
                <img src="@/assets/images/v2/img/icon_message.png" alt="Message">
              </div>
              <div class="la-list-content">
                <div class="la-list-item-text font-14 font-weight-600">
                  SMS
                </div>
              </div>
            </div>
          </div>
          <div class="section-bottom">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                  <div class="mb-2 box-info-2 pa-4 font-14 font-weight-400 olblack--text br-10">
                    {{ $t('v2.if_there_are_problems_contact_the_restaurant') }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-bottom-sheet v-model="dialog.limit_resend" content-class="dialog-icon">
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="mt-12 text-center mb-10">
                <img src="@/assets/images/v2/img/limit_resend.png" alt="Limit">
              </div>
              <div class="text-center">
                <div class="font-18 font-weight-700 ol-black mb-4">
                  {{ $t('v2.verification_reached_limit') }}
                </div>
                <div class="font-14 font-weight-400 ol-black mb-10" v-html="$t('v2.you_have_verified_several_times', { time: formatTimeLimit })" />
                <v-btn block color="white" class="br-5 text-none ol-elevation-1 font-weight-700 letter-spacing-normal" @click="dialog.limit_resend = false">
                  {{ $t('v2.cancel2') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import { requestOTP } from '@/api/auth'
import {
  getData as getCustomer
} from '@/api/customer'
export default {
  data() {
    return {
      dialog: {
        limit_resend: false
      },
      limit_time: 0,
      limitInterval: null,
      customer: {}
    }
  },
  computed: {
    formatTimeLimit() {
      let days = Math.floor(this.limit_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.limit_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.limit_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.limit_time % (1000 * 60)) / 1000)
      let result
      if (this.limit_time < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ':' : hours + ':'
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    }
  },
  watch: {
    formatTimeLimit: function(newItem) {
      if (newItem === 'EXPIRED' || newItem === '00:00') {
        this.dialog.limit_resend = false
      }
    }
  },
  mounted() {
    this.getDataCustomer()
  },
  methods: {
    async getDataCustomer() {
      try {
        const { data } = await getCustomer()
        this.customer = data.data
      } catch (e) {
        this.customer = {}
        console.log(e)
      }
    },
    async verify(type = 3) {
      try {
        const form = {
          phone: this.customer.phone,
          otp_type: type
        }
        const { data } = await requestOTP(form)
        const time = data.data.detail.expiry_date
        this.$router.push({ name: '_verification_phone', query: { type: 'old', otp_type: form.otp_type, phone: form.phone, expiry_date: time }}).catch(() => {})
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.code_sent_successfully')
        this.$store.state.error_type = 200
      } catch (e) {
        if (e.statusCode === 429) {
          this.dialog.limit_resend = true
          this.getLimitTime(e.data.unlocked_in)
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    getLimitTime(time) {
      const countDownDate = new Date(time).getTime()
      const _this = this
      this.limitInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.limit_time = countDownDate - now
        if (_this.limit_time < 0) {
          clearInterval(_this.limitInterval)
        }
      }, 1000)
    }
  }
}
</script>
